import { Tab, TabProps } from '@mui/material'

interface CustomTabProps extends TabProps {
  error?: boolean
  display?: boolean
}

export function CustomTab({ error = false, display = true, ...props }: CustomTabProps) {
  return (
    <Tab
      sx={[
        {
          borderBottom: '2px solid transparent',
          borderRadius: '8px 8px 0px 0px',
          textTransform: 'none',
          fontWeight: 500,
          color: theme => theme.palette.grey[500],
          '&.Mui-selected': {
            color: 'black',
            borderBottom: theme => `2px solid ${theme.palette.secondary.main}`
          }
        },
        error && {
          borderBottom: theme => `2px solid ${theme.palette.warning.main}`,
          color: theme => theme.palette.warning.main,
          backgroundColor: theme => theme.palette.warning.light
        }
      ]}
      style={{ display: display ? '' : 'none' }}
      {...props}
    />
  )
}
